import { useEffect, useState } from "react";
import AsideV2 from "../../../components/asidev2/AsideV2";
import "../home/Styles.css";
import getAllPlans from "../../../hooks/GetAllPlans";
import { updatePlan } from "../../../hooks/firebase";
import { FaCheck } from "react-icons/fa6";
import HeaderV2 from "../../../components/adminV2/header/Header";

export default function PlansV2() {
  const [plans, setPlans] = useState({});

  useEffect(() => {
    async function load() {
      const result = await getAllPlans();
      const formatted = result.reduce((acc, plan) => {
        acc[plan.id] = {
          ...plan,
          priceFormatted: formatToCurrency(plan.price),
        };
        return acc;
      }, {});
      setPlans(formatted);
    }
    load();
  }, []);

  const formatToCurrency = (value) =>
    new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value / 100);

  const currencyToNumber = (value) =>
    Number(value.replace(/\D/g, ""));

  const handleChange = (id, field, value) => {
    setPlans((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [field]:
          field === "price"
            ? formatToCurrency(Number(value.replace(/\D/g, "")))
            : value,
      },
    }));
  };

  const handleSave = async (id) => {
    const plan = plans[id];
    const updated = {
      ...plan,
      price: currencyToNumber(plan.priceFormatted),
      activeDays: parseInt(plan.activeDays, 10),
    };
    try {
      await updatePlan(updated);
      alert("Plano atualizado com sucesso!");
    } catch (err) {
      console.error(err);
      alert("Erro ao atualizar plano");
    }
  };

  return (
    <div>
      <AsideV2 />
      <main className="main-wrapper p-4">
        <HeaderV2 />
        <section className="section">
          <div className="container-fluid">
            <h2 className="mb-4">Planos</h2>
            <div className="row">
              {Object.entries(plans).map(([id, plan]) => {
                //if (plan.isVisibleTo === "nobody") return null;
                return (
                  <div className="col-xl-4 col-lg-6 col-md-12 mb-4" key={id}>
                    <div className="card h-100">
                      <div className="card-body d-flex flex-column">
                        <div className="mb-3">
                          <label className="form-label">Nome</label>
                          <input
                            type="text"
                            className="form-control"
                            value={plan.title}
                            onChange={(e) =>
                              handleChange(id, "title", e.target.value)
                            }
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Preço (R$)</label>
                          <input
                            type="text"
                            className="form-control"
                            value={plan.priceFormatted}
                            onChange={(e) =>
                              handleChange(id, "price", e.target.value)
                            }
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Dias ativo</label>
                          <input
                            type="number"
                            min="1"
                            className="form-control"
                            value={plan.activeDays}
                            onChange={(e) =>
                              handleChange(id, "activeDays", e.target.value)
                            }
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Visível para</label>
                          <select
                            className="form-select"
                            value={plan.isVisibleTo}
                            onChange={(e) =>
                              handleChange(id, "isVisibleTo", e.target.value)
                            }
                          >
                            <option value="CPF">CPF</option>
                            <option value="CNPJ">CNPJ</option>
                            <option value="Todos">Todos</option>
                            <option value="nobody">Nínguem</option>
                          </select>
                        </div>
                        <div className="mt-auto d-flex justify-content-end">
                          <button
                            className="btn btn-success"
                            onClick={() => handleSave(id)}
                          >
                            <FaCheck /> Salvar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
